import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Container } from 'react-bootstrap';

import { useToast } from '../../hooks/toast';
import { usePerfil } from '../../hooks/perfil';
import ProcedimentoCadastro from '../../components/ProcedimentoCadastro';

import Input from '../../components/Input';
import SelectSync, { IOption } from '../../components/SelectSync';

import Modal from '../../components/Modal';
import Button from '../../components/Button';

import getValidationErrors from '../../utils/getValidationErrors';
import ListaProcedimentos from '../../components/ListaProcedimentos';
import { useAuth } from '../../hooks/auth';

export interface IFormBusca {
  nome?: string;
  perfil?: string;
  situacao?: string;
  codigoTuss?: string;
  codigoAlvaro?: string;
}

const Procedimento: React.FC = () => {
  const history = useHistory();
  const { user, clinica } = useAuth();

  useEffect(() => {
    if (user.UsuTipo > clinica.CliPerfilAcessaProcedimentos) {
      history.push('/sempermissao');
    }
  }, [clinica.CliPerfilAcessaProcedimentos, history, user.UsuTipo]);

  const { addToast } = useToast();
  const { optionsPerfil, buscaPerfil } = usePerfil();
  const [dadosForm, setDadosForm] = useState<IFormBusca | undefined>(undefined);

  const formRefBusca = useRef<FormHandles>(null);

  const [showModalCadastro, setShowModalCadastro] = useState(false);

  const [optionPerfil, setOptionsPerfil] = useState<IOption[]>([]);

  useEffect(() => {
    async function loadPerfis(): Promise<void> {
      await buscaPerfil();
    }
    if (!optionsPerfil || Object.keys(optionsPerfil).length === 0) loadPerfis();
  }, [buscaPerfil, optionsPerfil]);

  useEffect(() => {
    try {
      setOptionsPerfil(optionsPerfil.optionPerfis);
    } catch (error) {
      addToast({
        title: 'Não foi possível buscar perfis',
        type: 'error',
      });
    }
  }, [addToast, optionsPerfil]);

  const handleSubmitBusca = useCallback(async (dados: IFormBusca) => {
    try {
      formRefBusca.current?.setErrors({});
      const schema = Yup.object().shape({
        nome: Yup.string(),
        perfil: Yup.string(),
        codigoTuss: Yup.string().nullable(true),
        codigoAlvaro: Yup.string().nullable(true),
        situacao: Yup.string().nullable(true),
      });

      await schema.validate(dados, {
        abortEarly: false,
      });
      setDadosForm(dados);
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErrors(error);
        formRefBusca.current?.setErrors(errors);
      }
    }
  }, []);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const handleOnChangeVazio = useCallback(() => {}, []);

  return (
    <Container fluid className="mt-2">
      {showModalCadastro && (
        <Modal
          show={showModalCadastro}
          titulo="Cadastro de Procedimento"
          handleFecharModal={() => setShowModalCadastro(false)}
          large
        >
          <ProcedimentoCadastro setShowModal={setShowModalCadastro} />
        </Modal>
      )}

      <div className="bg-white border p-2 mb-2">
        <div className="d-flex justify-content-between mb-2">
          <h2 id="topoBusca">Procedimentos</h2>
          <div>
            <Button
              type="button"
              variant="success"
              onClick={() => {
                setShowModalCadastro(true);
              }}
            >
              Novo Procedimento
            </Button>
          </div>
        </div>

        <Form ref={formRefBusca} onSubmit={handleSubmitBusca}>
          <div className="row">
            <div className="col-md-3 form-group">
              <Input
                name="nome"
                label="Procedimento"
                placeholder="NOME"
                maxLength={100}
                minLength={3}
              />
            </div>
            <div className="col-md-2 form-group">
              <SelectSync
                name="perfil"
                label="Perfil"
                placeholder="Selecione"
                isClearable
                handleSelectChange={handleOnChangeVazio}
                options={optionPerfil}
              />
            </div>
            <div className="col-md-2 form-group">
              <Input
                name="codigoAlvaro"
                label="Codigo Álvaro"
                placeholder="Código Álvaro"
                maxLength={12}
                minLength={1}
              />
            </div>
            <div className="col-md-2 form-group">
              <Input
                name="codigoTuss"
                label="Codigo TUSS"
                placeholder="Código TUSS"
                maxLength={9}
                minLength={3}
              />
            </div>
            <div className="col-md-2">
              <SelectSync
                name="situacao"
                label="Situação"
                placeholder="Selecione"
                isClearable
                handleSelectChange={handleOnChangeVazio}
                options={[
                  { label: 'Todos', value: '' },
                  { label: 'Ativo', value: 'true' },
                  { label: 'Desativado', value: 'false' },
                ]}
              />
            </div>
            <div className="col-md-1">
              <div className="input-group-append mt-3">
                <Button type="submit" variant="secondary-outline">
                  BUSCAR
                </Button>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="bg-white border p-2">
        <ListaProcedimentos dados={dadosForm} />
      </div>
    </Container>
  );
};

export default Procedimento;
